class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');

    // Right-hand mega menu image panel: swap it as the shopper hovers or
    // tabs through level-2 / level-3 links that carry a data-mega-menu-image
    // attribute (added in snippets/header-mega-menu.liquid for links that
    // point to a collection with an image set).
    this.image = this.querySelector('.mega-menu__image-media');
    if (this.image) {
      this.defaultImageSrc = this.image.getAttribute('src');
      this.defaultImageAlt = this.image.getAttribute('alt');
      this.querySelectorAll('[data-mega-menu-image]').forEach((menuLink) => {
        menuLink.addEventListener('mouseenter', this.onMegaMenuLinkHover.bind(this, menuLink));
        menuLink.addEventListener('focus', this.onMegaMenuLinkHover.bind(this, menuLink));
      });
    }

    // Open on hover instead of click, for pointer devices that support real
    // hover. Touch/keyboard users keep the native click/Enter toggle on the
    // <summary>, which still works untouched.
    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      this.addEventListener('mouseenter', this.onMouseEnterMenu.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeaveMenu.bind(this));
    }
  }

  onMegaMenuLinkHover(menuLink) {
    if (!this.image) return;
    const newSrc = menuLink.getAttribute('data-mega-menu-image');
    if (!newSrc || this.image.getAttribute('src') === newSrc) return;
    this.image.setAttribute('src', newSrc);
    this.image.setAttribute('alt', menuLink.getAttribute('data-mega-menu-image-alt') || '');
  }

  resetMegaMenuImage() {
    if (!this.image || !this.defaultImageSrc) return;
    this.image.setAttribute('src', this.defaultImageSrc);
    this.image.setAttribute('alt', this.defaultImageAlt || '');
  }

  onMouseEnterMenu() {
    clearTimeout(this.hoverCloseTimeout);
    document.querySelectorAll('header-menu > details[open]').forEach((details) => {
      if (details === this.mainDetailsToggle) return;
      const otherMenu = details.closest('header-menu');
      if (otherMenu && typeof otherMenu.close === 'function') {
        otherMenu.close();
        otherMenu.resetMegaMenuImage();
      } else {
        details.removeAttribute('open');
      }
    });
    this.mainDetailsToggle.open = true;
  }

  onMouseLeaveMenu() {
    this.hoverCloseTimeout = setTimeout(() => {
      this.close();
      this.resetMegaMenuImage();
    }, 150);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
